const CLASSES = {
    button: 'button',
    ticker: 'ticker',
    container: 'ticker__container',
    pause: 'ticker--pause',
    play: 'ticker--play',
    pauseLabel: 'cmp-button__text--pause',
    playLabel: 'cmp-button__text--play',
    tickerBase: 'ticker__content-base',
    tickerItem: 'ticker__item'
  };

  const loadTicker = () => {
    const ticker = document?.querySelector(`.${CLASSES.ticker}`);
    if (!ticker) return;
    const container = ticker.querySelector(`.${CLASSES.container}`);
    const button = ticker.querySelector(`.${CLASSES.button}`);
    const pauseLabel = button.querySelector(`.${CLASSES.pauseLabel}`);
    const playLabel = button.querySelector(`.${CLASSES.playLabel}`);
  
    const tickerBase = ticker.querySelector(`.${CLASSES.tickerBase}`);
    const itemCount = tickerBase.querySelectorAll(`.${CLASSES.tickerItem}`).length;
    const newDuration = 4 * itemCount;
    tickerBase.style.animationDuration = `${newDuration}s`;

    button.addEventListener('click', () => toggleTicker(container, pauseLabel, playLabel));
    toggleTicker(container, pauseLabel, playLabel);

    function toggleAriaHidden(element) {
        element.setAttribute('aria-hidden', element.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
      }
      
      function toggleTicker(container, pauseLabel, playLabel) {
        container.classList.toggle(CLASSES.pause);
        container.classList.toggle(CLASSES.play);
        toggleAriaHidden(pauseLabel);
        toggleAriaHidden(playLabel);
      }
  }
  
  if (document.readyState !== "loading") {
    loadTicker();
  } else {
    document.addEventListener("DOMContentLoaded", loadTicker);
  }
  